// ======================================================================
// File Name       : ChatForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button, Row } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import { VALIDATE_TYPE } from '../../constants/index';
import { MSG_NOT_ACCEPT_FILE } from '../../constants/MessageThreadContants';

class ChatForm extends React.Component {
  render() {
    const { contentMessage, fileSize, fileName, sendMessage, goBack, disableForm, isSending } = this.props;
    return (
      <div className="col-sm-12">
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            sendMessage();
          }}
          className='form-horizontal'
        >
          <Row>
            <Form.Group className="form-info" style={{ paddingTop: '0px', paddingBottom: '10px', }}>
              <Col sm={12}>
                <RenderField
                  type="textarea"
                  rows={7}
                  name="messageContent"
                  label="スレッド詳細"
                  className="text-area-fixed-size"
                />
              </Col>
            </Form.Group>
          </Row>
          <Form.Group className="form-info" style={{ paddingTop: '10px', marginBottom: '10px' }}>
            <Col sm={7}>
              <RenderField
                type="batchimport"
                name="attachmentFile"
                label="ファイル選択"
                validates={[VALIDATE_TYPE.DOCUMENT_SIZE, VALIDATE_TYPE.NOT_ACCEPT_FILE]}
                value={fileSize}
                fileName={fileName}
                fileSize={fileSize}
                notAccept={MSG_NOT_ACCEPT_FILE}
                accept={' '}
                fieldInput={7}
                fieldButton={4}
              />
            </Col>
          </Form.Group>
          <Row>
            <Form.Group className="form-info" style={{ paddingTop: '0px' }}>
              <Col sm={12} className="text-right">
                <Button
                  variant="primary"
                  className="btn-96"
                  type="submit"
                  onClick={this.props.handleSubmit(sendMessage)}
                  disabled={!contentMessage || isSending}
                >
                  送信
                </Button>
              </Col>
            </Form.Group>
          </Row>
        </Form>
      </div>
    );
  }
}

export default ChatForm;
